import { render, staticRenderFns } from "./drag-n-drop-files.vue?vue&type=template&id=6a3e61a4&lang=pug"
import script from "./drag-n-drop-files.vue?vue&type=script&lang=js"
export * from "./drag-n-drop-files.vue?vue&type=script&lang=js"
import style0 from "./drag-n-drop-files.vue?vue&type=style&index=0&id=6a3e61a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports